import { render, staticRenderFns } from "./SelecaoUnidade.vue?vue&type=template&id=79ea7be8&"
import script from "./SelecaoUnidade.vue?vue&type=script&lang=js&"
export * from "./SelecaoUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports